export default __webpack_public_path__ + "static/media/draw.2be261b6.svg";